/** 本番ビルドでもエージェントタブを開放するプラン */
const PRODUCTION_AGENT_PLAN_IDS: readonly string[] = ['free', 'starter'];

/**
 * ホームのエージェントタブを出すか。
 * development / staging ではプランに関係なく出す。
 * 本番ビルド（vite --mode production / eq-board）では Free / Starter のみ出す。
 * NCG 管理者かどうかは呼び出し側が決める。
 */
export function isAgentTabVisible(
  mode: string = import.meta.env.MODE,
  planId?: string | null,
): boolean {
  if (mode !== 'production') return true;
  return !!planId && PRODUCTION_AGENT_PLAN_IDS.includes(planId);
}

export type WorkspaceHomeLanding = 'agent' | 'dashboard' | 'pages';

/**
 * ワークスペースを開いたときの初期画面。
 * エージェントタブがある NCG 管理者はエージェント。
 * タブが無い NCG 管理者はダッシュボード。
 * それ以外はページ一覧。
 */
export function resolveWorkspaceHomeLanding(input: {
  mode?: string;
  planId?: string | null;
  isAdmin: boolean;
  isNcg: boolean;
}): WorkspaceHomeLanding {
  if (!input.isAdmin || !input.isNcg) return 'pages';
  return isAgentTabVisible(input.mode, input.planId) ? 'agent' : 'dashboard';
}
